import { Route } from "@faire/web-api/Route";
import { props as marketSpecialsRouteProps } from "@faire/web-api/routes/markets/event_type/all-specials";
import { props as marketsAllSpecialsMyMarketListRouteProps } from "@faire/web-api/routes/markets/event_type/all-specials/my-market-list";
import { Switch } from "@faire/web/ui/routing/Switch";
import { observer } from "mobx-react";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";

import {
  LazyPromotionsHub,
  LazyMyMarketList,
} from "@faire/retailer/features/FaireMarkets/PromotionsHub";
import { home } from "@faire/retailer/paths";
import { MarketStore } from "@faire/retailer/stores/domain/Events/FaireMarkets/MarketStore";

const MarketPreshowRouterBase: React.FunctionComponent = () => (
  <Suspense fallback={null}>
    <Switch>
      {MarketStore.get().showAllSpecials ? (
        <Route
          {...marketSpecialsRouteProps}
          component={LazyPromotionsHub}
          exact
        />
      ) : null}
      {MarketStore.get().showMarketList ? (
        <Route
          {...marketsAllSpecialsMyMarketListRouteProps}
          component={LazyMyMarketList}
        />
      ) : null}
      <Redirect to={home()} />
    </Switch>
  </Suspense>
);

export const MarketPreshowRouter = observer(MarketPreshowRouterBase);
